<template>
  <div class="mask" @click="hide" ref="cardRef">
    <div class="card_box" ref="cardBoxRef" @click.stop>
      <div class="close_btn">
        <div class="card_title">{{templeData.name}}
          <a v-if="templeData.name == '湄洲岛妈祖祖庙'" class="three_link" target="_blank" href="http://www.xmutsrsc.com/Global%20Mazu%20Temple%20List/index.html"> <i class="el-icon-link"></i> 湄洲岛三维平台</a>
        </div>
        <i class="el-icon-close" @click="hide"></i>
      </div>
      <div class="card_info roll" ref="cardInfoRef">
        <div class="menu_item">
          <div class="item_carousel card">
            <ImgList :imgUrl="templeData.picture"> </ImgList>
          </div>
        </div>
        <div class="menu_item">
          <div id="all_map"></div>
        </div>
        <div class="menu_item">
          <div class="table_box">
            <table>
              <tr>
                <!-- 名称 -->
                <th>{{$t("templeinfo.name")}}</th>
                <td colspan="3">{{templeData.name}}</td>

                <!-- 修建年代 -->
                <th>{{$t("templeinfo.years")}}</th>
                <td colspan="3">{{templeData.years}} （{{templeData.dynasty}}）</td>
              </tr>
              <tr>
                <!-- 洲 -->
                <th>{{$t("templeinfo.continent")}}</th>
                <td>{{templeData.continent}}</td>
                <!-- 国家 -->
                <th>{{$t("templeinfo.country")}}</th>
                <td>{{templeData.country}}</td>
                <!-- 省、州 -->
                <th>{{$t("templeinfo.province")}}</th>
                <td>{{templeData.province}}</td>
                <!-- 市 -->
                <th>{{$t("templeinfo.city")}}</th>
                <td>{{templeData.city}}</td>
              </tr>
              <tr>
                <!-- 地址 -->
                <th>{{$t("templeinfo.address")}}</th>
                <td colspan="7">{{templeData.address}}</td>
              </tr>
              <tr>
                <!-- 父庙 -->
                <th>{{$t("templeinfo.father")}}</th>
                <td colspan="3">{{templeData.father_name}}</td>
                <!-- 上传者 -->
                <th>{{$t("templeinfo.uploader")}}</th>
                <td colspan="3">{{templeData.uploader}}</td>
              </tr>
              <tr>
                <!-- 描述 -->
                <th>{{$t("templeinfo.description")}}</th>
                <td colspan="7">{{templeData.description}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="menu_item">
          <!-- 人文历史： -->
          <div class="more_title"> {{$t("templeinfo.history")}}：</div>
          <div class="table_box">
            <table>
              <tr>
                <!-- 例祭 -->
                <th>{{$t("templeinfo.sacrifice")}}</th>
                <td colspan="3">{{moreInfo.sacrifice}}</td>
              </tr>
              <tr>
                <!-- 是否迁徙 -->
                <th>{{$t("templeinfo.migration")}}</th>
                <td>{{moreInfo.migration == "1"?"是":"否"}}</td>
                <!-- 迁徙原址 -->
                <th>{{$t("templeinfo.migrationRoot")}}</th>
                <td>{{moreInfo.migrationRoot}}</td>
              </tr>
              <tr>
                <!-- 迁徙原因 -->
                <th>{{$t("templeinfo.migrationReason")}}</th>
                <td colspan="3">{{moreInfo.migrationReason}}</td>
                <!-- <td colspan="3">{{common.dictionary("迁徙原因", moreInfo.migrationReason)}}</td> -->
              </tr>
              <tr>
                <!-- 保存状况 -->
                <th>{{$t("templeinfo.saveStatr")}}</th>
                <td>{{moreInfo.saveStatr}}</td>
                <!-- <td>{{common.dictionary("保存状况", moreInfo.saveStatr)}}</td> -->
                <!-- 是否修缮 -->
                <th>{{$t("templeinfo.repair")}}</th>
                <td>{{moreInfo.repair == "1"?"是":"否"}}</td>
              </tr>
              <tr>
                <!-- 修缮记录 -->
                <th>{{$t("templeinfo.repairRecord")}}</th>
                <td colspan="3">{{moreInfo.repairRecord}}</td>
              </tr>
              <tr>
                <!-- 损坏类型 -->
                <th>{{$t("templeinfo.damageType")}}</th>
                <!-- <td>{{moreInfo.damageType}}</td> -->
                <td>{{common.dictionary("损坏原因类型", moreInfo.damageType)}}</td>

                <!-- 损坏原因 -->
                <th>{{$t("templeinfo.damageReason")}}</th>
                <td>{{moreInfo.damageReason}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="menu_item">
          <!-- 建筑风格： -->
          <div class="more_title"> {{$t("templeinfo.style")}}：</div>
          <div class="table_box">
            <table>
              <tr>
                <!-- 建筑宽度 -->
                <th>{{$t("templeinfo.buildWidth")}}</th>
                <td>{{moreInfo.buildWidth}}m</td>
                <!-- 建筑长度 -->
                <th>{{$t("templeinfo.buildLength")}}</th>
                <td>{{moreInfo.buildLength}}m</td>
              </tr>
              <tr>
                <!-- 建筑层数 -->
                <th>{{$t("templeinfo.buildFloor")}}</th>
                <td>{{moreInfo.buildFloor}}{{$t("templeinfo.c")}}</td>
                <!-- 建筑面积 -->
                <th>{{$t("templeinfo.buildArea")}}</th>
                <td>{{moreInfo.buildArea}}m²</td>
              </tr>
              <tr>
                <!-- 庙区宽度 -->
                <th>{{$t("templeinfo.districtWidth")}}</th>
                <td>{{moreInfo.districtWidth}}m</td>
                <!-- 庙区长度 -->
                <th>{{$t("templeinfo.districtLength")}}</th>
                <td>{{moreInfo.districtLength}}m</td>
              </tr>
              <tr>
                <!-- 庙区面积 -->
                <th>{{$t("templeinfo.districtArea")}}</th>
                <td>{{moreInfo.districtArea}}m²</td>
                <!-- 建筑数量 -->
                <th>{{$t("templeinfo.buildNum")}}</th>
                <td>{{moreInfo.buildNum}}{{$t("templeinfo.s")}}</td>
              </tr>
              <tr>
                <!-- 建筑风格 -->
                <th>{{$t("templeinfo.buildStyle")}}</th>
                <td>{{moreInfo.buildStyle}}</td>
                <!-- 建筑结构类型 -->
                <th>{{$t("templeinfo.buildType")}}</th>
                <!-- <td>{{moreInfo.buildType}}</td> -->
                <td>{{common.dictionary("建筑结构类型", moreInfo.buildType)}}</td>
              </tr>
              <tr>
                <!-- 建筑布局 -->
                <th>{{$t("templeinfo.bulidLayout")}}</th>
                <!-- <td>{{moreInfo.bulidLayout}}</td> -->
                <td>{{common.dictionary("建筑布局", moreInfo.bulidLayout)}}</td>
                <!-- 墙体材料 -->
                <th>{{$t("templeinfo.wallType")}}</th>
                <!-- <td>{{moreInfo.wallType}}</td> -->
                <td>{{common.dictionary("墙体材料", moreInfo.wallType)}}</td>
              </tr>
              <tr>
                <!-- 屋瓦 -->
                <th>{{$t("templeinfo.watts")}}</th>
                <!-- <td>{{moreInfo.watts}}</td> -->
                <td>{{common.dictionary("屋瓦", moreInfo.watts)}}</td>
                <!-- 屋顶 -->
                <th>{{$t("templeinfo.roof")}}</th>
                <!-- <td>{{moreInfo.roof}}</td> -->
                <td>{{common.dictionary("屋顶", moreInfo.roof)}}</td>
              </tr>
              <tr>
                <!-- 雀替纹样 -->
                <th>{{$t("templeinfo.texture")}}</th>
                <!-- <td>{{moreInfo.texture}}</td> -->
                <td>{{common.dictionary("雀替纹样", moreInfo.texture)}}</td>
                <!-- 窗的形式 -->
                <th>{{$t("templeinfo.window")}}</th>
                <!-- <td>{{moreInfo.window}}</td> -->
                <td>{{common.dictionary("窗户样式", moreInfo.window)}}</td>
              </tr>
              <tr>
                <!-- 柱子形式 -->
                <th>{{$t("templeinfo.pillarsStyle")}}</th>
                <!-- <td>{{moreInfo.pillarsStyle}}</td> -->
                <td>{{common.dictionary("柱子形式", moreInfo.pillarsStyle)}}</td>
                <!-- 柱子材料 -->
                <th>{{$t("templeinfo.pillarsMaterial")}}</th>
                <!-- <td>{{moreInfo.pillarsMaterial}}</td> -->
                <td>{{common.dictionary("柱子材料", moreInfo.pillarsMaterial)}}</td>
              </tr>
              <tr>
                <!-- 柱础 -->
                <th>{{$t("templeinfo.pillarsBasis")}}</th>
                <!-- <td>{{moreInfo.pillarsBasis}}</td> -->
                <td>{{common.dictionary("柱础", moreInfo.pillarsBasis)}}</td>
                <!-- 柱子装饰 -->
                <th>{{$t("templeinfo.pillarsDecoration")}}</th>
                <!-- <td>{{moreInfo.pillarsDecoration}}</td> -->
                <td>{{common.dictionary("柱面装饰", moreInfo.pillarsDecoration)}}</td>
              </tr>
              <tr>
                <!-- 屋脊 -->
                <th>{{$t("templeinfo.ridge")}}</th>
                <!-- <td>{{moreInfo.ridge}}</td> -->
                <td>{{common.dictionary("屋脊", moreInfo.ridge)}}</td>
                <!-- 屋脊装饰 -->
                <th>{{$t("templeinfo.ridgeDecoration")}}</th>
                <!-- <td>{{moreInfo.ridgeDecoration}}</td> -->
                <td>{{common.dictionary("屋脊装饰", moreInfo.ridgeDecoration)}}</td>
              </tr>
              <tr>
                <!-- 铺地 -->
                <th>{{$t("templeinfo.floor")}}</th>
                <!-- <td>{{moreInfo.floor}}</td> -->
                <td>{{common.dictionary("铺地", moreInfo.floor)}}</td>
                <!-- 建筑支撑结构 -->
                <th>{{$t("templeinfo.support")}}</th>
                <!-- <td>{{moreInfo.support}}</td> -->
                <td>{{common.dictionary("建筑支撑结构", moreInfo.support)}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgList from "./ImgList.vue";
import { mapGetters } from "vuex";
export default {
  name: "AllInfo",
  components: {
    ImgList,
    // TimeLine,
  },
  props: {
    info: Object,
  },
  computed: {
    ...mapGetters([
      "bulidLayout",
      "watts",
      "roof",
      "texture",
      "pillarsStyle",
      "pillarsMaterial",
      "pillarsBasis",
      "pillarsDecoration",
      "ridgeDecoration",
      "support",
      "window",
      "buildType",
      "migrationType",
      "saveStatr",
      "damageType",
      "floor",
      "ridge",
      "wallType",
      "fatherTemple",
    ]),
  },
  data() {
    return {
      // isShow: false,
      moreInfo: {}, //详细信息
      templeData: {},
      maps: null,
      nowMaker: null,
    };
  },
  watch: {
    info(newVal, oldVal) {
      this.templeData = newVal;
      // 将maker标记的位置设置为获取到的妈祖庙的坐标
      this.nowMaker.setLatLng([newVal.latitude, newVal.longitude]);
      // 调整地图显示，将maker标记置为地图中心
      this.maps.flyTo([newVal.latitude, newVal.longitude], 8);
      this.getMoreInfo();
    },
  },
  mounted() {
    this.initmap(); //加载地图
  },
  methods: {
    // 详细信息 地图
    initmap() {
      var that = this;
      let map = this.$leaflet.map("all_map", {
        minZoom: 1,
        maxZoom: 18,
        // 范围限制
        maxBounds: [
          //south west
          [90, -270],
          //north east
          [-90, 360],
        ],
        center: [25.090924, 119.147698],
        zoom: 3,
        zoomControl: true,
        attributionControl: false,
      });
      this.$leaflet.tileLayer(this.common.mapurl).addTo(map);
      map._onResize();
      // maker样式
      var makerIcon = this.$leaflet.icon({
        iconUrl: "./static/img/maker.png", //maker图片
        shadowUrl: "./static/img/mshadow.png", //maker阴影
        iconSize: [24, 30], // 图标的大小
        shadowSize: [26, 20], // 阴影的大小
        iconAnchor: [12, 30], // 图标的点，该点将与标记的位置相对应
        shadowAnchor: [4, 18], // the same for the shadow
        popupAnchor: [2, -30], //弹出窗口相对于图标打开的点
      });
      // 添加一个不可移动的maker，用来表示妈祖庙位置
      var marker = this.$leaflet
        .marker([25.090574, 119.146299], { icon: makerIcon })
        .addTo(map);
      that.maps = map;
      that.nowMaker = marker;
    },

    // 更多信息滚动条置顶
    scroll() {
      // 滚动条置顶
      // document.querySelector(".el-dialog__wrapper").scrollTop = 0;
    },

    show() {
      // this.isShow = true;
      this.$refs.cardRef.style.marginTop = "0";
      this.$refs.cardBoxRef.style.marginTop = "0";
      this.$nextTick(() => {
        this.$refs.cardInfoRef.scrollTop = 0;
      });
    },
    hide() {
      // this.isShow = false;

      this.$refs.cardBoxRef.style.marginTop = "100vh";
      setTimeout(() => {
        this.$refs.cardRef.style.marginTop = "100vh";
      }, 300);
    },
    getMoreInfo() {
      let pardata = { templeID: this.templeData.id };
      // this.$Loading.show();
      this.http.From("temple/getTempleInfo", pardata).then((res) => {
        //  this.$Loading.hide();
        if (res.code == "0") {
          this.moreInfo = res.data;
          // this.$message({
          //   message: "获取详细信息成功",
          //   type: "success",
          // });
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/_common.scss";

.mask {
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 100vh;
  .card_box {
    margin-top: 100vh;
    width: 50%;
    background: rgb(255, 255, 255);
    position: absolute;
    top: $head-height;
    left: 50%;
    margin-left: -25%;
    height: calc(100vh - $head-height - 4rem);
    border-radius: $r-mid;
    transition: all 0.3s;

    .close_btn {
      color: $c-main;
      font-size: $f-hug;
      margin: $m-lit;
      padding-right: $m-mid;
      text-align: right;
      .card_title {
        float: left;
        color: $c-main;
        margin-left: $m-mid;
        .three_link {
          display: inline-block;
          width: auto;
          padding: 0.2rem 0.6rem;
          font-size: $f-lit;
          border-radius: 1rem;
          text-decoration: none;
          background: $c-success;
          color: #fff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
          &:hover {
            transform: scale(1.05);
            background-color: $c-second;
            transition: all 0.3s;
          }
        }
      }
      i {
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: rotate(180deg);
          color: $c-second;
        }
      }
    }
    .card_info {
      width: 90%;
      height: calc(100vh - $head-height - 9rem);
      margin: 0 auto;
      overflow: hidden;
      overflow-y: auto;

      .item_carousel {
        margin: 0 auto;
        margin-bottom: $m-lit;
        overflow: hidden;
      }
      #all_map {
        height: 20rem;
        border-radius: $r-mid;
        box-sizing: border-box;
        box-shadow: $shadow;
        margin: 0 auto;
        margin-bottom: $m-lit;
      }
      .menu_item {
        margin: 0 auto;
        padding: $m-lit;
        .left_btn {
          font-size: $f-lit;
          display: flex;
          justify-content: space-around;
          align-items: center;
          span {
            opacity: 0.8;
            cursor: pointer;
            &:hover {
              color: $c-main;
            }
          }
        }
        .more_title {
          color: $c-main;
          margin: $m-lit;
        }
        .table_box {
          border-radius: $r-min;
          table {
            width: 100%;
            color: $c-text-main;
            border-collapse: collapse;
            tr,
            th,
            td {
              border: 1px solid $c-main-light;
              // line-height: 1.5rem;
              font-size: $f-lit;
              padding: 0;
              margin: 0;
            }
            th {
              width: 6rem;
            }
            td {
              min-width: 4rem;
              padding: 0.1rem 0.2rem;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 451px) and (max-width: 650px) {
  .mask {
    .card_box {
      width: 80%;
      left: 50%;
      margin-left: -40%;
    }
  }
}

@media screen and (max-width: 450px) {
  .mask {
    .card_box {
      width: 100%;
      left: 50%;
      margin-left: -50%;
    }
    .card_box {
      height: calc(100vh - $head-height);
    }
  }
}
</style>
